import { render, staticRenderFns } from "./confirm-data-change.vue?vue&type=template&id=529aea1c&scoped=true&lang=pug"
import script from "./confirm-data-change.vue?vue&type=script&lang=ts"
export * from "./confirm-data-change.vue?vue&type=script&lang=ts"
import style0 from "./confirm-data-change.vue?vue&type=style&index=0&id=529aea1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529aea1c",
  null
  
)

export default component.exports